@if (side !== 'none') {
  <div>
    @if (side === 'subscriptions') {
      <app-support-select-subscription-v2 (onSubscriptionSelected)="selectSubscription($event)"></app-support-select-subscription-v2>
    }
    @if (side === 'ticket') {
      <app-create-ticket-form-v2 [subscription]="subscription"></app-create-ticket-form-v2>
    }
  </div>
}
